// src/App.js - ATUALIZAR (adicionar rota de Pesquisa Jurisprudência)
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ClientProvider } from './contexts/ClientContext'; // ✅ NOVO
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import Layout from './layout/Layout';
import Login from './pages/Login';
import ClientData from './pages/ClientData';
import ChatWithAI from './pages/ChatWithAI';
import ConsultaCodigoPenal from './pages/ConsultaCodigoPenal';
import GerarDocumentos from './pages/GerarDocumentos';
import Usuarios from './pages/Usuarios';
import GestaoCasos from './pages/GestaoCasos';
import NovoCaso from './pages/NovoCaso';
import DetalheCaso from './pages/DetalheCaso';
import Dashboard from './pages/Dashboard';
import PesquisaJurisprudencia from './pages/PesquisaJurisprudencia'; // NOVA IMPORTAÇÃO
import useNavigationLogger from './hooks/useNavigationLogger';
import Estatisticas from './pages/Estatisticas'; // ✅ ADICIONAR após outras importações
import ConferirDocumento from './pages/ConferirDocumento';
import CalculoHonorarios from './pages/CalculoHonorarios';
import MeusDocumentos from './pages/MeusDocumentos';
import Workflows from './pages/Workflows';
import WorkflowEditor from './pages/Workflows/Editor';
import WorkflowExecucoes from './pages/Workflows/Execucoes';
import Auditorias from './pages/Auditorias';
import AuditoriaDetalhe from './pages/Auditorias/Detalhe';
import AuditoriaConfiguracoes from './pages/Auditorias/Configuracoes';
import Sso from './pages/Sso';

import './App.css';

// Componente que usa o hook de navegação
const NavigationLogger = () => {
  useNavigationLogger();
  return null;
};

function App() {
  return (
    <AuthProvider>
      <ClientProvider> {/* ✅ NOVO */}
        <Router>
          <NavigationLogger />
          <Routes>
            <Route path="/login" element={<Login />} />
            {/* Entrada pelo SedLex: sessão vem no fragmento do URL */}
            <Route path="/sso" element={<Sso />} />

            {/* Rota do chat - NÃO protegida */}
            <Route path="/chat-with-ai" element={<ChatWithAI />} />
            
            {/* Rota da Dashboard - FORA do Layout padrão */}
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            
            {/* Rotas protegidas */}
            <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              {/* Redirecionar a rota raiz para gestao-casos */}
              <Route index element={<Navigate to="/gestao-casos" replace />} />
              <Route path="gestao-casos" element={<GestaoCasos />} />
              <Route path="gestao-casos/novo" element={<NovoCaso />} />
              <Route path="gestao-casos/:id" element={<DetalheCaso />} />
              <Route path="pesquisa-jurisprudencia" element={<PesquisaJurisprudencia />} /> {/* NOVA ROTA */}
              <Route path="clientdata" element={<ClientData />} />
              <Route path="gerar-documentos" element={<GerarDocumentos />} />
              <Route path="usuarios" element={<Usuarios />} />
              <Route path="consulta-codigo-penal" element={<ConsultaCodigoPenal />} />
              <Route path="estatisticas" element={<Estatisticas />} />
              <Route path="conferir-documento" element={<ConferirDocumento />} />
              <Route path="calculo-honorarios" element={<CalculoHonorarios />} />
              <Route path="meus-documentos" element={<MeusDocumentos />} />
              <Route path="workflows" element={<Workflows />} />
              <Route path="workflows/novo" element={<WorkflowEditor />} />
              <Route path="workflows/:id/editar" element={<WorkflowEditor />} />
              <Route path="workflows/:id/execucoes" element={<WorkflowExecucoes />} />
              <Route path="auditorias" element={<Auditorias />} />
              {/* Antes de :id — o React Router dá prioridade ao segmento fixo,
                  mas a ordem torna-o óbvio a quem lê */}
              <Route
                path="auditorias/configuracoes"
                element={<AdminRoute para="/auditorias"><AuditoriaConfiguracoes /></AdminRoute>}
              />
              <Route path="auditorias/:id" element={<AuditoriaDetalhe />} />
            </Route>
          </Routes>
        </Router>
       </ClientProvider> {/* ✅ NOVO */}
    </AuthProvider>
  );
}

export default App;